var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 112 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: "4px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5651 87L65.6451 100.64L46.2651 111.69L38.5551 98.54L68.8651 81.26L2.96509 43.21V30.79L68.8651 68.84L60.9151 55.12L50.0951 36.45L38.5551 16.55L46.2651 12.31L65.3751 45.28L76.2051 63.95L82.5351 74.87L89.5651 87Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.565 77L89.5651 87L82.5351 74.87L76.2051 63.95L65.3751 45.28L46.2651 12.31L66.2651 2.31L109.565 77Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.565 77L66.2651 101.69L46.2651 111.69L65.6451 100.64L89.5651 87L109.565 77Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8651 68.84L2.96509 30.79L22.9651 20.79L50.0951 36.45L60.9151 55.12L68.8651 68.84Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow2.5a3a69fde37c266049e8db1aa92cbb89.svg";
export { ForwardRef as ReactComponent };